import React from 'react';
import { Icon } from './Icon.js';
export const IconBellFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m10.75,7.5c-.414,0-.75-.336-.75-.75v-2.75c0-2.206-1.794-4-4-4S2,1.794,2,4v2.75c0,.414-.336.75-.75.75s-.75.336-.75.75.336.75.75.75h9.5c.414,0,.75-.336.75-.75s-.336-.75-.75-.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m6,12c1.105,0,2-.895,2-2h-4c0,1.105.895,2,2,2Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconBellFill12.js.map